import { useInfiniteQuery } from '@tanstack/react-query';

import { useMemberhubApi } from '../api';
import { memberhubKeys } from '../query-key-factory';
import { DirectoryFamiliesResponse, DirectoryIndividualsResponse } from './directory.types';

const useInfiniteListDirectoryByFamily = ({
  organizationId,
  queryString,
  enabled = true,
}: {
  organizationId?: string;
  queryString?: string;
  enabled?: boolean;
}) => {
  const MemberhubApi = useMemberhubApi();

  const getDirectoryFamilies = async ({ pageParam = { limit: 12, offset: 0 } }) => {
    const { data } = await MemberhubApi.get<DirectoryFamiliesResponse>(
      `/directory?search=${queryString}&order[families.name]=asc&group_by[value]=family&organization_uuid=${organizationId}&limit=${pageParam.limit}&offset=${pageParam.offset}`
    );
    return data;
  };

  const key = organizationId
    ? memberhubKeys.organizations.id(organizationId).directory.families.all
    : [];
  return useInfiniteQuery({
    queryKey: [...key, queryString],
    queryFn: getDirectoryFamilies,
    initialPageParam: { limit: 12, offset: 0 },
    getNextPageParam: (lastPageData) => {
      const { meta } = lastPageData;
      const { has_more, limit, offset } = meta;
      if (!has_more) {
        return undefined;
      }
      return { limit, offset: offset + limit };
    },
    enabled: !!organizationId && enabled,
  });
};

const useInfiniteListDirectoryByIndividual = ({
  organizationId,
  queryString,
  enabled = true,
}: {
  organizationId?: string;
  queryString?: string;
  enabled?: boolean;
}) => {
  const MemberhubApi = useMemberhubApi();

  const getDirectoryIndividuals = async ({ pageParam = { limit: 12, offset: 0 } }) => {
    const { data } = await MemberhubApi.get<DirectoryIndividualsResponse>(
      `/directory?search=${queryString}&order[last_name]=asc&group_by[value]=individual&organization_uuid=${organizationId}&limit=${pageParam.limit}&offset=${pageParam.offset}`
    );
    return data;
  };

  const key = organizationId
    ? memberhubKeys.organizations.id(organizationId).directory.individuals.all
    : [];
  return useInfiniteQuery({
    queryKey: [...key, queryString],
    queryFn: getDirectoryIndividuals,
    initialPageParam: { limit: 12, offset: 0 },
    getNextPageParam: (lastPageData) => {
      const { meta } = lastPageData;
      const { has_more, limit, offset } = meta;
      if (!has_more) {
        return undefined;
      }
      return { limit, offset: offset + limit };
    },
    enabled: !!organizationId && enabled,
  });
};

export { useInfiniteListDirectoryByFamily, useInfiniteListDirectoryByIndividual };
